<template>
  <a-input-number
    :value="props.modelValue"
    :placeholder="placeholder"
    :onInput="dataChange"
    style="width: 100%"
    v-if="!props.disabled"
  />
  <span class="comValue" v-else>{{ props.modelValue }}</span>
</template>

<script setup>
  import { defineProps, defineEmits } from 'vue'
  const emit = defineEmits()

  const props = defineProps({
    modelValue: {
      required: true, //是否必传
    },
    label: {
      type: String, // 参数类型
      required: true, //是否必传
    },
    value: {
      required: true, //是否必传
    },
    placeholder: {
      type: String, // 参数类型
    },
    disabled: {
      type: Boolean,
      default: false,
    }
  })
  const placeholder = props.placeholder
    ? props?.placeholder
    : `请输入${props?.label}`

  function dataChange(data) {
    emit('update:modelValue', data)
  }
</script>

<style lang="less" scoped></style>
